// @ts-nocheck
export const initialStatePageKey = 'crehanaApp';
export const COUPON_LANDING_PAGE_KEY = 'coupon-landing';
